import {observer} from 'mobx-react';
import React from 'react';

import {TrackerInitializer} from '@udemy/event-tracking';

import {DemoFormHeader} from '../demo-form-header/demo-form-header.react-component';
import styles from './demo-form-layout.module.less';

export const getDemoFormLayout = (page: React.ReactElement) => {
    return <DemoFormLayout>{page}</DemoFormLayout>;
};

const DemoFormLayout = observer(({children}: {children: React.ReactElement}) => {
    return (
        <>
            <DemoFormHeader />
            <div className={styles['container']}>
                <main className={styles['content']}>{children}</main>
            </div>
            <TrackerInitializer />
        </>
    );
});
